// extracted by mini-css-extract-plugin
module.exports = {"buttonProceed":"WrongLicenceBar_buttonProceed__Hb0iO","wrong-licence-overlay":"WrongLicenceBar_wrong-licence-overlay__aAAuE"};